import { KommerSnart } from '../../../components/ui/KommerSnart'

export function SkabelonerTab() {
  return (
    <KommerSnart
      description="E-mailskabeloner, brevskabeloner og brugerdefinerede felter til dokumentgenerering."
    />
  )
}
